import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'; // ①
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardWhatsappService {
  private readonly baseUrl =
    'https://qa1.sicopweb.com/DashboardWhatsAppApi/mty'; // ②

  constructor(
    private http: HttpClient // ③
  ) {}

  getDashboardWhats(
    idDistribuidor: string,
    idMarca: string,
    eMail: string,
    registryId: string,
    token: string,
    inicio: string,
    fin: string
  ): Observable<any> {
    const params = new HttpParams()
      .set('IdDistribuidor', idDistribuidor)
      .set('IdMarca', idMarca)
      .set('eMail', eMail)
      .set('RegistryId', registryId)
      .set('Token', token)
      .set('inputFin', fin)
      .set('inputInicio', inicio);

    console.log('PARAMS: ', params);

    return this.http.get(`${this.baseUrl}/dashboard-whats`, { params });
  }
  getDashboardWhatsDetails(
    idDistribuidor: string,
    idMarca: string,
    eMail: string,
    registryId: string,
    token: string,
    inicio: string,
    filtro: string,
    fin: string,
    detail = 0
  ): Observable<any> {
    const params = new HttpParams()
      .set('IdDistribuidor', idDistribuidor)
      .set('IdMarca', idMarca)
      .set('eMail', eMail)
      .set('RegistryId', registryId)
      .set('Token', token)
      .set('inputFin', fin)
      .set('filter', filtro)
      .set('inputInicio', inicio)
      .set('detail', detail.toString());

    console.log(params);

    return this.http.get(`${this.baseUrl}/dashboard-whats`, { params });
  }
  getUrlRedirect(
    idDistribuidor: string,
    idMarca: string,
    eMail: string,
    registryId: string,
    token: string,
    idProspecto: string
  ): Observable<any> {
    const params = new HttpParams()
      .set('IdDistribuidor', idDistribuidor)
      .set('IdMarca', idMarca)
      .set('eMail', eMail)
      .set('RegistryId', registryId)
      .set('Token', token)
      .set('IdProspecto', idProspecto);

    console.log(params);

    return this.http.get(`${this.baseUrl}/dashboard-whats/getUrl`, { params });
  }
}
